import React, { useEffect, useState } from 'react'
import '../../assets/scss/custom/inbox/dialogStyles.scss'
import "../../assets/scss/custom/inbox/DialogDetails.scss"
import { ReactComponent as PeopleFill } from "../../assets/images/inbox/people-fill.svg";
import { ReactComponent as PersonCircle } from "../../assets/images/inbox/person-circle.svg";
import { ReactComponent as ChatLeft } from "../../assets/images/inbox/chat-left.svg";
import { ReactComponent as ArrowLeft } from "../../assets/images/inbox/arrow-left-circle.svg";
import { useDialogManager } from "./helperHooks/HelperContext"
import { Spinner } from 'reactstrap';

export default function CreateDialog() {
    const
        {
            createDialogModal,
            view, setView,
            userList,
            loader,
            dmOutsideExperienceSetup,
            checkedUserIds,
            setCheckedUserIds,
            dialogDetails,
            setDialogDetails,
            selectedChat,
            handlecreateDialog,
            inputHandler,
            handleupdateOrnextButton,
            invitePeopleStatus,
            handleAddOccupats,
            stateResetHandler,
            newInvitingPeople,
            handleFileChange, handleUploadClick,
            fileInputRef,
            getDialogProfileImage,
            loading,
            getFromLocalStorage
        } = useDialogManager();

    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        if (createDialogModal?.type === 1) {
            setView({ ...view, buttonsArea: true });
        }
    }, [createDialogModal])

    useEffect(() => {
        if (createDialogModal?.type === 2 && selectedChat?.name) {
            setDialogDetails({ ...dialogDetails, name: selectedChat.name, image: selectedChat?.photo });
        }
    }, [createDialogModal?.type, selectedChat]);


    const handleBackClick = () => {
        setView({ buttonsArea: true, createGroupArea: false, userListArea: false })
        setDialogDetails({ name: null, dialogType: 1 })
        setCheckedUserIds([])
    };

    const handleCheckboxChange = (userId, isChecked) => {
        if (dialogDetails?.dialogType === 3) {
            if (isChecked) {
                setCheckedUserIds([userId]);
            } else {
                setCheckedUserIds([]);
            }
        } else {
            if (isChecked) {
                setCheckedUserIds(prev => [...prev, userId]);
            } else {
                setCheckedUserIds(prev => prev?.filter(id => id !== userId));
            }
        }
    };

    const isCheckboxDisabled = (userId) => {
        return (
            dialogDetails?.dialogType === 3 &&
            checkedUserIds.length === 1 &&
            !checkedUserIds.includes(userId)
        );
    };


    // Handle Exclude Logged-in User From the Userlist
    let myQbId = null;
    if (view?.userListArea) {
        const userData = getFromLocalStorage('ngStorage-user');
        myQbId = userData?.chat_credentials?.qb_id || null;
    }


    return (
        <>
            <div>

                {/* Modal */}
                <div className="modal slide-modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "380px" }}>
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {
                                        view?.buttonsArea ? "Start Conversation"
                                            : view?.createGroupArea ? "Create A Group"
                                                : view?.createGroupArea ? "Select Members"
                                                    : null
                                    } </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={stateResetHandler}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {/* Button Area */}
                                {view?.buttonsArea ? (
                                    <>
                                        <div className="d-grid gap-2">
                                            <button className="btn btn-outline-light d-flex align-items-center justify-content-start" type="button" style={{ padding: "18px", gap: "10px", borderColor: "#75b35b" }}
                                                onClick={() => dmOutsideExperienceSetup("Private")}>
                                                <ChatLeft height="20px" width="20px" fill='#75b35b' />
                                                Direct Message (1:1)
                                            </button>

                                            <button className="btn btn-outline-light d-flex align-items-center justify-content-start" type="button" style={{ padding: "18px", gap: "10px", borderColor: "#75b35b" }}
                                                onClick={() => dmOutsideExperienceSetup("Group")}>
                                                <PeopleFill height="20px" width="20px" fill='#75b35b' />
                                                Group Message (1:Many)
                                            </button>
                                        </div>
                                    </>
                                ) : view?.userListArea ? (
                                    <>
                                        {/* User List area */}
                                        <div style={{ flexGrow: 1, overflowY: 'auto', maxHeight: '400px' }}>
                                            <div
                                                style={{
                                                    position: 'sticky',
                                                    top: "0px",
                                                    zIndex: 10,
                                                    backgroundColor: 'white',
                                                    paddingBottom: '10px'
                                                }}
                                            >
                                                {(createDialogModal?.type === 1) &&
                                                    <ArrowLeft
                                                        width="32"
                                                        height="32"
                                                        className='backbtn-svg-hover'
                                                        onClick={handleBackClick}
                                                    />}
                                                <br></br>

                                                {/* Search Bar */}
                                                <br></br>
                                                <input
                                                    type="text"
                                                    className="form-control mb-2 custom-input-focus"
                                                    placeholder="Search user..."
                                                    value={searchTerm}
                                                    style={{ maxWidth: "325px", width: "100%", marginLeft: "5px" }}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            {loader ? (
                                                [...Array(5)].map((_, idx) => (
                                                    <div className="skeleton-post" key={idx}>
                                                        <div className="skeleton-avatar"></div>
                                                        <div className="skeleton-lines">
                                                            <div className="skeleton-line short"></div>
                                                            <div className="skeleton-line long"></div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                userList
                                                    ?.filter((item) =>
                                                        item?.user?.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) &&
                                                        item?.user?.id !== myQbId
                                                    )
                                                    .map((item, index) =>
                                                        invitePeopleStatus && newInvitingPeople?.includes(item?.user?.id) ? null :
                                                            (<div className="list-group" key={index}>
                                                                <button
                                                                    type="button"
                                                                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center user-item"
                                                                    style={{ marginBottom: '7px', overflow: 'hidden' }}
                                                                    onClick={() =>

                                                                        handleCheckboxChange(
                                                                            item?.user?.id,
                                                                            !checkedUserIds.includes(item?.user?.id)
                                                                        )}
                                                                >
                                                                    <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0 }}>
                                                                        <PersonCircle
                                                                            style={{
                                                                                width: '25px',
                                                                                height: '25px',
                                                                                marginRight: '8px',
                                                                                flexShrink: 0,
                                                                            }}
                                                                            fill="#75b35b"
                                                                        />
                                                                        <span
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                flexGrow: 1,
                                                                            }}
                                                                        >
                                                                            {item.user?.full_name}
                                                                        </span>
                                                                    </div>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checkedUserIds.includes(item?.user?.id)}
                                                                        readOnly
                                                                        style={{ marginLeft: '10px', flexShrink: 0 }}
                                                                        disabled={isCheckboxDisabled(item?.user?.id)}
                                                                    />
                                                                </button>

                                                            </div>
                                                            ))
                                            )}
                                        </div>
                                        {/*End User List area */}
                                    </>
                                ) : view?.createGroupArea &&
                                <>
                                    {/* create Group Area */}
                                    <div className="text-center p-4 border rounded shadow-sm bg-light" style={{ maxWidth: '300px', margin: '0 auto' }}>
                                        <div className="d-flex align-items-center justify-content-center mb-3">
                                            {loading ? <Spinner className="ms-2" color="primary" /> : <>

                                                <div className="rounded-circle overflow-hidden me-3" style={{ width: '70px', height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: "1px solid  #47c89a" }}>

                                                    {dialogDetails?.image && dialogDetails?.image !== "null" ? <img
                                                        className="bi bi-people-fill rounded-circle"
                                                        width="70"
                                                        height="70"
                                                        src={getDialogProfileImage(dialogDetails?.image)}
                                                        alt="Group Avatar"
                                                        loading="lazy"

                                                    /> : <PeopleFill width="40" height="40" fill="#47c89a" />}

                                                </div>
                                                <button className="btn btn-outline-success" onClick={handleUploadClick}>Upload</button>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    ref={fileInputRef}
                                                    onChange={handleFileChange}
                                                    style={{ display: "none" }}
                                                />
                                            </>


                                            }
                                        </div>

                                        <input type="text"
                                            className="form-control  mb-2 custom-input-focus"
                                            value={dialogDetails?.name}
                                            placeholder="Enter Group Name"
                                            onChange={inputHandler}
                                        />
                                    </div>
                                </>
                                }
                                {/* create Group Area */}
                            </div>
                            {view?.userListArea &&
                                <div className="modal-footer">

                                    <button
                                        type="button"
                                        className="btn btn-success text-white mt-2 w-100 d-flex justify-content-center align-items-center"
                                        onClick={invitePeopleStatus ? handleAddOccupats : handlecreateDialog}
                                        disabled={loading} // optional: prevent double-click while loading
                                    >
                                        {loading ? (
                                            <Spinner className="ms-2" color="primary" />
                                        ) : (
                                            invitePeopleStatus ? "Invite People" : "Create"
                                        )}
                                    </button>

                                </div>
                            }


                            <div className="modal-footer">
                                {(view?.createGroupArea && createDialogModal?.type === 1) &&
                                    <button type="button" className="btn btn-outline-success mt-2" onClick={() => {
                                        setView({ buttonsArea: true, createGroupArea: false, userListArea: false })
                                    }}>
                                        Back
                                    </button>}
                                {(view?.createGroupArea && createDialogModal?.type === 1 || view?.createGroupArea && createDialogModal?.type === 2) &&
                                    <button type="button"
                                        className="btn btn-outline-success mt-2 ms-auto"
                                        onClick={() => { handleupdateOrnextButton(createDialogModal?.type) }}>
                                        {createDialogModal?.type === 1 ? "Next" : "Update"}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
